<template>
  <span>
    <border-style-options
      :mode="mode"
      :border-style="selected.borderStyle || 'none'"
      :border-color="selected.borderColor || null"
      :border-width="selected.borderWidth || 0"
      :show-border-radius="false"
      :update-prop-function="
        (key, value) => updateProp({ key: key, value: value })
      "
    />
  </span>
</template>

<script>
import * as _ from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import * as actions from '../../../store/modules/actions'
import * as getters from '../../../store/modules/getters'
import BorderStyleOptions from './BorderStyleOptions.vue'

export default {
  components: {
    BorderStyleOptions,
  },
  props: {
    mode: {
      type: String,
      default: 'LIGHT',
    },
  },

  computed: {
    ...mapGetters({
      selected: getters.SELECTOR_SELECTED,
    }),
  },

  methods: {
    ...mapActions({
      updateProp: actions.SELECTOR_UPDATE_PROP,
    }),
  },
}
</script>
